/** 度 → ラジアン。Roblox の Orientation/Angles は度、World の回転はラジアン。 */
export const degToRad = (deg: number): number => (deg * Math.PI) / 180

/** 変数が保持し得る値（Lua の動的型を数値/文字列に割り切って近似）。 */
export type PreviewValue = number | string

/** PreviewValue を数値へ変換する（数値文脈用）。非有限・変換不能は 0。 */
export const toNumber = (value: PreviewValue | undefined): number => {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : 0
  }
  const parsed = Number(value)
  return Number.isFinite(parsed) ? parsed : 0
}

/** looks_seeThrough の透明度（Lua: Transparency = 0.5）。 */
export const SEE_THROUGH_TRANSPARENCY = 0.5
/** looks_show の透明度（Lua: Transparency = 0）。 */
export const SHOW_TRANSPARENCY = 0
/** looks_hide の透明度（Lua: Transparency = 1）。 */
export const HIDE_TRANSPARENCY = 1
